import React from "react";

export default class ErrorHandle extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      
      return <div>Something went wrong: {this.state.error.message}</div>;
    }

    return this.props.children;
  }
}